export default __webpack_public_path__ + "static/media/wallet-icon-home-mobile.81271d9b.webp";